// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications{position:fixed;z-index:3000;max-width:500px;width:100%;opacity:.97}", ""]);
// Exports
module.exports = exports;
